import { LitElement, html, css } from 'lit-element'
import { JWPlayerStyle } from './jwplayer.styles'
import GAVideoTracker from './ga-tracker'
let INSTANCE_COUNT = 0

export default class JWPlayer extends LitElement {

	static get properties() {
		return {
			playerId: String,
			playerUrl: String,
			playListId: String,
			playListUrl: String,
			aspectRatio: String,
			playList: Object,
			mediaId: String,
			autoStart: String,
			options: Object,
			playListId: String,
			videoId: String,
			mute: Boolean,
			title: String,
			initialized: Boolean,
			controls: Boolean,
			withTracking: {
				type: Boolean,
				reflect: true,
				attribute: 'with-tracking'
			},
			nostick: Boolean,
			ads: Boolean,
			adUnit: String,
			custTags: String,
			custSection: String,
		}
	}

	set options(value) {
		if(typeof value == 'string')
			value = JSON.parse(value.replace(/\n/g, '\\n'))
		this._options = value
	}

	get options() {
		return this._options
	}

	set playList(value) {
		if(typeof value === 'string')
			try {
				value = JSON.parse(value.replace(/\n/g, '\\n'))
			} catch (ignore) {
				/* property playList is defined as Object type so hypothetically we should never have had to parse it */
			}
		this.changePlayList(value)
	}

	get playList() {
		return this._playList
	}

	set playListUrl(value) {
		this.changePlayList(value)
	}

	get playListUrl() {
		return ('string' == typeof this._playList) ?this._playList :false
	}

	set playListId(value) {
		this.changePlayList('https://cdn.jwplayer.com/v2/playlists/'+value)
	}

	get playListId() {
		if ('string' != typeof this._playList)
			return false
		return this._playList.match(/^http:\/\/cdn.jwplayer.com\/v2\/playlists\/(\w+)$/) && RegExp.$1
	}

	set mediaId(value) {
		this.changePlayList(`http://content.jwplatform.com/feeds/${value}.json`)
	}

	get mediaId() {
		if ('string' != typeof this._playList)
			return false
		return this._playList.match(/^http:\/\/content.jwplatform.com\/feeds\/(\w+).json$/) && RegExp.$1
	}

	get videoId() {
		return this._videoId ? this._videoId :
			(this._videoId = this.playerId + '-' + Math.floor(Math.random() * 1e16).toString(32))
	}

	changePlayList(playlist) {
		var oldPlayList= JSON.stringify(playlist)
		if (this.oldPlayList == oldPlayList) {
			if (this.jwplayer) this.jwplayer.play()
		} else {
			this.oldPlayList= oldPlayList
			this._playList= playlist
			if (this.jwplayer) {
				this.jwplayer.remove()
				this.onJWLoaded({target:{onload:null}})
				this.jwplayer.play()
			}
		}
	}

	get playerLib() {
		return this.playerUrl ?
			this.playerUrl :
			`https://cdn.jwplayer.com/libraries/${this.playerId}.js`
	}

	// get mute() {
	// 	if(!this.player)
	// 		return this.hasAttribute('mute')
	// 	else
	// 		return this.player.getMute()
	// }

	// set mute(value) {
	// 	if(value == null)
	// 		this.removeAttribute('mute')
	// 	else if(this.player)
	// 		this.player.setMute(value)
	// }

	constructor() {
		super()
		this.oldPlayList = false
		this.options = {}
		this.autoStart = 'viewable'
		this.playerId = 'uD1427Ts'
		this.playListUrl = 'https://cdn.jwplayer.com/v2/playlists/U09OFT24'
		this.aspectRatio = '16 / 9';
		this.controls = true
		this.ads = true
	}

	render() {
		return html`
			<style>${JWPlayerStyle}</style>
			<div id=${this.videoId}></div>
		`
	}

	createRenderRoot() {
		return this
	}

	firstUpdated() {
		//TODO: refactor to method and promisify
		this.instanceCount = ++INSTANCE_COUNT
		let script = document.createElement('script')
		script.src = this.playerLib
		script.onload = script.onreadystatechange = this.onJWLoaded.bind(this)
		this.appendChild(script)
		this.style.setProperty('--aspect-ratio', this.aspectRatio);
	}

	configureAdSchedule(config) {

		if (!config.advertising)
			return config
		if (!config.advertising.schedule)
			return config
		config.advertising.schedule= config.advertising.schedule.map(sched => {
			if (!sched.tag)
				return sched

			let url= new URL(sched.tag)
			url.searchParams.set('description_url', '__page-url__')

			if (this.adUnit) {
				url.searchParams.set('iu', this.adUnit)
			}
			let cust= new URLSearchParams(url.searchParams.get('cust_params'))
			if (this.custSection) {
				cust.set('Section', this.custSection)
			}
			cust.set('v_title', '')

			url.searchParams.set('cust_params', cust.toString())

			sched.tag= url.toString()
			return sched
		}, this)
		return config
	}

	onJWLoaded(event) {
		const ar = this.aspectRatio.replace(/\s*\/\s*/g, ':')
		this.jwplayer= window.jwplayer(this.videoId)
		const baseConfig = {
			playlist: this.playList,
			aspectratio: ar,
			advertising: {
				maxRedirects: 6,
			},
			autostart: this.instanceCount == 1 ? this.autoStart : 'false',
			mute: this.hasAttribute('mute'),
			title: this.title,
			controls: this.controls,
			ga: this.withTracking ? { label: 'title' } : null,
			ph: 2,
			floating: {
				dismissible: true
			}
		}
		const configList = [ baseConfig, window.jwplayer.defaults||{}, this.options ]
		const config = configList.reduce(this.md(), {})
		if (!this.ads || 'false' == this.ads)
			config.advertising= {}

		this.config = this.configureAdSchedule(config)
		if(this.hasAttribute('nostick')) {
			delete this.config.floating
			delete (window['jwDefaults'] || {}).floating
		}

		this.jwplayer.setup(this.config)
		event.target.onload = null

		if(this.autoStart && this.autoStart != 'false' && this.autoStart != 'viewable' && this.instanceCount == 1)
			this.forceAutoPlay()

		if(this.withTracking)
			try {
				this.tracker = new GAVideoTracker(this.jwplayer)
			} catch (e) {
				console.error('GA:',e)
			}
	}

	forceAutoPlay() {

		let playFn = () => this.jwplayer.getState() == 'idle' && this.jwplayer.play() && console.log('starting video')
		this.jwplayer.once('breakpoint', playFn)
	}

	md() {
		function isMergeable(y) {
			return Array.isArray(y) || ('object'===typeof y && !(y instanceof Date) && !(y instanceof RegExp))
		}
		function mergeDefaults(dst = {}, src) {
			if (Array.isArray(dst) && Array.isArray(src)) {
				src.forEach(function(val, key) {
					if ('undefined'===typeof dst[key]) {dst[key]= val}
					else if (isMergeable(val)) {dst[key]= mergeDefaults(dst[key], val)}
					else if (-1===dst.indexOf(val)) {dst.push(val)}
				})
			} else if (isMergeable(dst)) {
				Object.keys(src).forEach(function (key) {
					if (!(key in dst)) {
						dst[key]= src[key]
					} else if (isMergeable(dst[key])) {
						dst[key]= mergeDefaults((dst[key]||{}), src[key])
					}
				})
			}
			return dst
		}
		return function(d,s) {return mergeDefaults(d,s)}
	}
}